import * as React from 'react';
import FirstSlide from './FirstSlide';
import BottomSlide from './BottomSlide';

type Props = {
  peekRef: React.RefObject<HTMLDivElement>,
  grabHandlers: Pick<React.HTMLAttributes<HTMLDivElement>, 'onPointerDown' | 'onPointerMove' | 'onPointerUp' | 'onPointerCancel'>,
  handle: React.ReactNode,
};

const BottomSheetContent = ({ peekRef, grabHandlers, handle }: Props): JSX.Element => (
  <>
    <div
      className="sheet__peek"
      ref={peekRef}
      onPointerDown={grabHandlers.onPointerDown}
      onPointerMove={grabHandlers.onPointerMove}
      onPointerUp={grabHandlers.onPointerUp}
      onPointerCancel={grabHandlers.onPointerCancel}
    >
      {handle}
      <FirstSlide />
    </div>

    <div className="sheet__body">
      <BottomSlide />
    </div>
  </>
);

export default BottomSheetContent;
